const ClusterModel = {};

ClusterModel.TYPE = {
  OPTIONS: {
    id: 1,
    title: 'Options',
    DISPLAY_TYPE: {
      SELECT: 'select',
      GROUP: 'group',
      RADIO: 'radio',
    },
  },
};

ClusterModel.TYPE.OPTIONS.DEFAULT_CLUSTER = {
  type: ClusterModel.TYPE.OPTIONS.id,
  displayType: ClusterModel.TYPE.OPTIONS.DISPLAY_TYPE.GROUP,
  order: Infinity,
  optionsCountBeforeLoadMore: 4,
};

ClusterModel.TYPE.OPTIONS.DEFAULT_NAME = 'default';
ClusterModel.TYPE.OPTIONS.DEFAULT_CLUSTER_NAME = 'Choose Extras';
ClusterModel.TYPE.OPTIONS.DEFAULT_DIFFICULTY_CLUSTER_NAME = 'Additional Options';

ClusterModel.TYPE.ID_TO_DATA = {
  [ClusterModel.TYPE.OPTIONS.id]: ClusterModel.TYPE.OPTIONS,
};

export default ClusterModel;
